// A latitude/longitude of exactly (0, 0) is a common bad-data/fallback
// sentinel, not a real location -- treat it the same as missing coordinates.
export function hasValidGpsCoordinates(loc: {
  latitude?: number | null;
  longitude?: number | null;
}): boolean {
  return (
    loc.latitude != null &&
    loc.longitude != null &&
    !(loc.latitude === 0 && loc.longitude === 0) &&
    Math.abs(loc.latitude) <= 90 &&
    Math.abs(loc.longitude) <= 180
  );
}
